export default {
  'importBatchesGrid.fileName': 'File Name',
  'importBatchesGrid.importDate': 'Import Date',
  'importBatchesGrid.map': 'Map',
  'importBatchesGrid.importMode': 'Import Mode',
  'importBatchesGrid.importType': 'Import Type',
  'importBatchesGrid.name': 'Name',
  'importBatchesGrid.achSenderName': 'ACH Sender',
  'importBatchesGrid.paymentType': 'Payment Type',
  'importBatchesGrid.batchDescription': 'Batch Description',
  'importBatchesGrid.status': 'Status',
  'importBatchesGrid.numDebits': 'Debit Count',
  'importBatchesGrid.totalDebits': 'Total Debits',
  'importBatchesGrid.numCredits': 'Credit Count',
  'importBatchesGrid.totalCredits': 'Total Credits',
  'importBatchesGrid.accept.success': 'Import Batch Accepted',
  'importBatchesGrid.delete.success': 'Import Batch Deleted',
  'importBatchesGrid.fileupload.success': 'File Upload Successful.',
  'importBatchesGrid.fileupload.successAdditionalMessage':
    'See list below for individual import batch status. Imported batch templates must be individually viewed and accepted before being available for use. Template approval requirements may apply.'
};
